import { cn } from '@up2stay/up2promo-ui';
import { type ReactNode } from 'react';

import { REPUTATION_SECTION_MUTED_CLASS } from '@/core/components/reputation/reputation-surface';

export function EmptyStage({
  message,
  icon,
}: {
  message: string;
  icon?: ReactNode;
}) {
  return (
    <div className="flex min-h-[280px] flex-col items-center justify-center gap-3 rounded-[var(--r-card)] border border-dashed border-border bg-muted/30 px-6 py-12 text-center sm:min-h-[360px]">
      {icon ? <div className="text-muted-foreground">{icon}</div> : null}
      <p className={cn(REPUTATION_SECTION_MUTED_CLASS, 'max-w-md text-pretty')}>
        {message}
      </p>
    </div>
  );
}
